export const SELECT_ALL_VALUE = '-1';
